// src/components/providerAssignments/PriorityChip.tsx

import type { AssignmentPriority } from '../../types/api';
import { PRIORITY_CHIP, PRIORITY_LABELS } from './assignmentDisplay';

export function PriorityChip({ priority }: { priority: AssignmentPriority }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${PRIORITY_CHIP[priority]}`}
      data-testid={`assignment-priority-${priority}`}
    >
      {PRIORITY_LABELS[priority]}
    </span>
  );
}
